module.exports = __webpack_public_path__ + "img/upload.f3fa82d8.svg";